const WalletCheck = ({ color = 'white' }: { color: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 23C6 23 7 23 8 25C8 25 11.1765 20 14 19"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 25H20C22.8284 25 24.2426 25 25.1213 24.1213C26 23.2426 26 21.8284 26 19V17C26 14.1716 26 12.7574 25.1213 11.8787C24.2426 11 22.8284 11 20 11H14M6 19V15C6 11.2288 6 9.34315 7.17157 8.17157C8.34315 7 10.2288 7 14 7H18C18.93 7 19.395 7 19.7765 7.10222C20.8117 7.37962 21.6204 8.18827 21.8978 9.22354C22 9.60504 22 10.07 22 11"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M20 17.5C20 18.3284 20.6716 19 21.5 19C22.3284 19 23 18.3284 23 17.5C23 16.6716 22.3284 16 21.5 16C20.6716 16 20 16.6716 20 17.5Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);

export default WalletCheck;
